import type React from 'react';
import {Outlet} from 'react-router';
import {Box} from '@mui/system';
import {SimpleEnvWrapper} from '~/jobs/wrapper/SimpleEnvWrapper';

/** Databag-loading wrapper for Explore Categories and the Category Profile. */
export const CategoryModuleLayout: React.FC = () => (
    <SimpleEnvWrapper state={{fluid: true, appSection: 'category-profile'}}>
        <Box sx={{p: 2, height: 'calc(100vh - 64px)', overflow: 'auto'}}>
            <Outlet/>
        </Box>
    </SimpleEnvWrapper>
);
